import { TrendingDown, TrendingUp } from "lucide-react";
import { cn } from "@/lib/utils";
import type { RegionMetric } from "@/types/geodata";

const bandClass: Record<RegionMetric["band"], string> = {
  stable: "border-emerald-500/35 text-emerald-200",
  watch: "border-amber-500/35 text-amber-200",
  pressure: "border-orange-500/40 text-orange-200",
  critical: "border-red-500/45 text-red-200",
};

export function MetricCard({ metric }: { metric: RegionMetric }) {
  const rising = metric.delta >= 0;

  return (
    <article className={cn("rounded-md border bg-card p-3", bandClass[metric.band])}>
      <div className="flex items-start justify-between gap-2">
        <p className="text-xs uppercase text-muted-foreground">{metric.label}</p>
        {rising ? <TrendingUp className="h-4 w-4" /> : <TrendingDown className="h-4 w-4" />}
      </div>
      <div className="mt-3 flex items-end justify-between">
        <p className="text-2xl font-semibold">
          {metric.value}
          <span className="text-sm text-muted-foreground">{metric.unit}</span>
        </p>
        <p className={cn("text-sm", rising ? "text-red-300" : "text-emerald-300")}>
          {rising ? "+" : ""}
          {metric.delta}
        </p>
      </div>
    </article>
  );
}
